/* src/interviews/Scene.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

import AvailabilityCard from './cards/AvailabilityCard';
import InterviewFormCard from './cards/InterviewFormCard';
import InterviewRequestsCard from './cards/InterviewRequestsCard';
import UpcomingInterviewsCard from './cards/UpcomingInterviewsCard';
import FillInterviewForm from './cards/FillInterviewForm';

import { fetchInterviews } from './actions';

class Interviews extends React.Component {
  componentDidMount() {
    this.props.fetchInterviews();
  }

  render() {
    const { classes } = this.props;
    return (
      <Grid container className={classes.root} spacing={16}>
        <Grid item xs={12} md={6}>
          <Grid container spacing={16}>
            <Grid item xs={12}>
              <InterviewRequestsCard />
            </Grid>
            <Grid item xs={12}>
              <UpcomingInterviewsCard />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <FillInterviewForm />
        </Grid>
        <Grid item xs={12} md={6}>
          <AvailabilityCard />
        </Grid>
        <Grid item xs={12} md={6}>
          <InterviewFormCard />
        </Grid>
      </Grid>
    );
  }
}

Interviews.propTypes = {
  classes: PropTypes.object.isRequired,
  fetchInterviews: PropTypes.func.isRequired,
};

const styles = () => ({
  root: {
    flexGrow: 1,
  },
});

const mapStateToProps = () => ({

});

const mapDispatchToProps = dispatch => ({
  fetchInterviews: () => dispatch(fetchInterviews()()),
});

export default compose(
  withStyles(styles, { name: 'Interviews' }),
  connect(mapStateToProps, mapDispatchToProps)
)(Interviews);



// WEBPACK FOOTER //
// ./src/modules/interviews/Scene.js